<template>
  <div class="sidebar-second">
    <div
      v-for="(group, key) in treeToUse"
      :key="key"
      class="sidebar-second__item"
    >
      <div
        :class="[
          'sidebar-second__item-title',
          { 'sidebar-second__item-title_clickable': group.to },
          {
            'sidebar-second__item-title_active':
              group.id === groupActive && group.to,
          },
        ]"
      >
        <router-link
          v-if="group.to"
          :to="group.to"
        >
          <h5>{{ group.title }}</h5>
        </router-link>
        <h5 v-else>
          {{ group.title }}
        </h5>
      </div>

      <div
        v-if="group.items?.length"
        class="sidebar-second__item-items"
      >
        <EpkSidebarItem
          v-for="item in group.items"
          :key="item.id"
          :class="[
            { disabled: item.disabled },
            {
              'sidebar-second__item-items-active':
                item.id === route.params.scope,
            },
          ]"
          :item="item"
          :to="item.to"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import type { IItemSidebarGroup } from '@/components/Layouts/EpkSidebar/types';
import { itemRouteTreeGet } from '@/pages/AggregatedDataItem/helpers/itemRouteTreeGet';

import { EpkSidebarItem } from './EpkSidebarItem';

export interface IProps {
  scopeAddressesMap?: Record<string, string[]>;
  scopeMap?: Record<string, string>;
  hasChanges?: boolean;
  hasTitle?: boolean;
  routeName?: string;
  tree?: IItemSidebarGroup[];
}

const props = defineProps<IProps>();

const route = useRoute();
const treeToUse = ref<IItemSidebarGroup[]>([]);

const treeApplyFromProps = () => {
  if (typeof props.tree === 'undefined') return;

  treeToUse.value = props.tree;

  return true;
};

const treeInit = () => {
  const listItems = itemRouteTreeGet(
    route.params.id as string,
    props.routeName,
    props.scopeMap,
    props.scopeAddressesMap,
    props.hasTitle,
    props.hasChanges,
    route.query
  ) as unknown as IItemSidebarGroup[];
  treeToUse.value = listItems;
};

const groupActive = computed(() => {
  const scope = route.params.scope;
  if (!scope) return undefined;

  for (const group of treeToUse.value) {
    if (group.id === scope) return group.id;

    const i = group.items?.find(i => i.id === scope);
    if (i) return group.id;
  }

  return undefined;
});

watch(
  () => [props.tree, route.params.id],
  () => {
    if (treeApplyFromProps()) return;
    treeInit();
  },
  { immediate: true }
);
</script>

<style lang="scss">
@import './EpkSidebarSecond';
</style>
